import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

import { Image, ImageWrap } from './PlaceholderWidget.styled';

interface PlaceholderWidgetProps {
  withImage?: boolean;
}

export const PlaceholderWidget = ({ withImage }: PlaceholderWidgetProps) => {
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'PlaceholderWidget' });

  return (
    <Box
      sx={{
        display: 'flex',
        flex: '1',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <Typography component="div" variant="caption" color="textPrimary">
        {t('description')}
      </Typography>
      {withImage && (
        <ImageWrap>
          <Image />
        </ImageWrap>
      )}
    </Box>
  );
};
